/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useState } from "react";
import { Box, Button, FlexContainer, theme } from "@nordcloud/gnui";
import { ChartTableSortField } from "~/generated/graphql";
import { Option, SearchBoxContainer, SortDirection } from "~/components";
import { EstateSortV2 } from "../EstateSortV2";

type Props = {
  sortField: ChartTableSortField;
  sortDirection: SortDirection;
  sortOptions: Option[];
  onSortSelect: (value: ChartTableSortField) => void;
  onSortDirectionSelect: (direction: SortDirection) => void;
  disabled?: boolean;
};

export function ChartParametersBar({
  sortField,
  sortDirection,
  sortOptions,
  onSortSelect,
  onSortDirectionSelect,
  disabled,
}: Props) {
  const [searchInput, setSearchInput] = useState("");

  return (
    <>
      <Box boxStyle="lightGrey" marginBottom={theme.spacing.spacing04}>
        <FlexContainer justifyContent="space-between">
          <FlexContainer alignItems="center" wrap="wrap">
            <span
              css={{
                marginRight: theme.spacing.spacing04,
                zIndex: theme.zindex.dropdown,
              }}
            >
              <EstateSortV2<ChartTableSortField>
                sortField={sortField}
                sortDirection={sortDirection}
                options={sortOptions}
                disabled={disabled}
                onSortOrderChange={onSortDirectionSelect}
                onSortSelect={onSortSelect}
              />
            </span>
            <SearchBoxContainer
              searchInput={searchInput}
              width="20rem"
              setSearchInput={setSearchInput}
              disabled={disabled}
            />
          </FlexContainer>
          <FlexContainer>
            <Button disabled icon="export" severity="medium">
              Export to CSV
            </Button>
          </FlexContainer>
        </FlexContainer>
      </Box>
    </>
  );
}
